//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from '@/components/objects/IconView.vue'
import { getUserAvatarDisplay } from '@/utils/userPublic.js'

export default {
  name: 'UserPublicAvatar',
  components: { IconView },
  props: {
    user: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'sm',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
  },
  computed: {
    avatar() {
      return getUserAvatarDisplay(this.user)
    },
    hasPhoto() {
      return this.avatar.type === 'photo'
    },
    hasIcon() {
      return this.avatar.type === 'icon'
    },
    photoUrl() {
      return this.avatar.url
    },
    iconId() {
      return this.avatar.iconId
    },
  },
}
